import { getQueryParameterFromUrl } from '@ms/yammer-web-support/dist/location';
import type { QnAAppType } from 'state/teams';

type GetMeetingTenantIdFromQueryParam = (url: string) => string | undefined;
export const getMeetingTenantIdFromQueryParam: GetMeetingTenantIdFromQueryParam = (url) =>
  getQueryParameterFromUrl(url, 'meetingTenantId');

type GetQnAAppTypeFromQueryParam = (url: string) => QnAAppType;
export const getQnAAppTypeFromQueryParam: GetQnAAppTypeFromQueryParam = (url) =>
  getQueryParameterFromUrl(url, 'qnaAppType') === 'native' ? 'native' : 'platform';

type GetDeeplinkEntrypointFromQueryParam = (url: string) => string | undefined;
export const getDeeplinkEntrypointFromQueryParam: GetDeeplinkEntrypointFromQueryParam = (url) =>
  getQueryParameterFromUrl(url, 'entryPoint');

type GetCallIdFromQueryParam = (url: string) => string | undefined;
export const getCallIdFromQueryParam: GetCallIdFromQueryParam = (url) => getQueryParameterFromUrl(url, 'callId');

type GetMeetingTemplateFromQueryParam = (url: string) => string | undefined;
export const getMeetingTemplateFromQueryParam: GetMeetingTemplateFromQueryParam = (url) =>
  getQueryParameterFromUrl(url, 'meetingTemplate');

type GetNetworkIdFromQueryParam = (url: string) => string | undefined;
export const getNetworkIdFromQueryParam: GetNetworkIdFromQueryParam = (url) =>
  getQueryParameterFromUrl(url, 'networkId');

type GetPridFromQueryParam = (url: string) => string | undefined;
export const getPridFromQueryParam: GetPridFromQueryParam = (url) => getQueryParameterFromUrl(url, 'prid');
